import React, { useEffect, useState } from "react";
import { backendGetRequest, backendGetRequestWithCache } from "../../../helpers/callBackend";
import { documentTitle } from "../../../components/header/documentTitle";
import TableWithLoadingWrapper from "../../../components/generic/dataGrid";
import GenericDropdown from "../../../components/generic/genericDropdown";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import TeamInviteModal from "../../../components/specific/company/team/TeamInviteModal";
import TeamDeleteModal from "../../../components/specific/company/team/TeamDeleteModal";
import TeamRoleSelect from "../../../components/specific/company/team/TeamRoleSelect";
import TeamPermissionField from "../../../components/specific/company/team/TeamPermissionField";
import TeamPermissionModal from "../../../components/specific/company/team/TeamPermissionModal";
import ReinviteTeammate from "../../../components/specific/team/reinviteTeammate";
import HeaderBox from "../../../components/generic/arpariBoxes/headerBox";
import TeamRolesInfoModal from "../../../components/specific/company/team/TeamRolesInfoModal";
import { IconButton } from "@mui/material";

import Button from "@mui/material/Button";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox";
import { useUcs } from '../../../helpers/contexts/UserCompanySettingsContext'
import StyledAlert from '../../../components/generic/StyledAlert'
import checkFlag from "../../../helpers/featureFlags";
import GenericTagChips from "../../../components/specific/customTags/genericTagChips";

const BA_TAG = 1;

/*
 * Team management page
 */
function TeamPermissions() {
  const [userCompanyPermissions, setUserCompanyPermissions] = useState([]);
  const [ucsLoaded, setUcsLoaded] = useState(false);
  const [selectedUcs, setSelectedUcs] = useState(0);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [inviteModalVisible, setInviteModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [currentUserIsAdmin, setCurrentUserIsAdmin] = useState(false);
  const [roleInfoVisible, setRoleInfoVisible] = useState(false)
  const [usersWithoutPhoneNumber, setUsersWithoutPhoneNumber] = useState([])
  const [phoneNumberToolTip, setPhoneNumberTooltip] = useState('')

  const [flattenedTags, setFlattenedTags] = useState([]);
  const [flattenedTagsPageCountExpected, setFlattenedTagsPageCountExpected] = useState(0);
  const [flattenedTagsPageCountReceived, setFlattenedTagsPageCountReceived] = useState(-1);
  const [flattenedTagsLoading, setFlattenedTagsLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(true);
  const [groupsPageCountReceived, setGroupsPageCountReceived] = useState(0);
  const [groupsPageCountExpected, setGroupsPageCountExpected] = useState(-1);


  const isSoftwareCustomer = JSON.parse(localStorage.getItem("isSoftwareCustomer"))
  const isBankingCustomer = JSON.parse(localStorage.getItem("isBankingCustomer"))

  const ucsContext = useUcs()

  useEffect(() => {
    if (!ucsContext.loaded) {
      return
    }
    setCurrentUserIsAdmin(ucsContext.isAdmin())
  }, [ucsContext])

  const getUCSObjects = async () => {
    const ucsObjects = await backendGetRequest("/api/landlord/permissions/");
    if (ucsObjects.status == 200) {
      setUserCompanyPermissions(ucsObjects.data.data);
      setUcsLoaded(true);
    }
  };

  useEffect(() => {
    documentTitle()
    getUCSObjects()

    backendGetRequest('/api/generic-tag/group/', { params: { page_index: 0, group_type: BA_TAG } }).then((res) => {
      setGroupsPageCountExpected(res?.data?.total_pages)
      for (let i = 1; i <= res?.data?.total_pages; i++) {
        backendGetRequestWithCache(
          'api/generic-tag/group/',
          { params: { page_index: i, group_type: BA_TAG } },
          (cachedResponse) => {
            if (!cachedResponse) return
            const cachedGroups = cachedResponse?.data?.generic_groups || []
            setGroups((prevState) => {
              const updatedGroups = prevState ? [...prevState] : []
              cachedGroups.forEach((group) => {
                if (!updatedGroups.some((existingGroup) => existingGroup.id === group.id)) {
                  updatedGroups.push(group)
                }
              })
              return updatedGroups
            })
          },
          (nonCachedResponse) => {
            const nonCachedGroups = nonCachedResponse?.data?.generic_groups || []
            if (nonCachedGroups) {
              setGroups((prevState) => {
                const updatedGroups = prevState ? [...prevState] : []
                nonCachedGroups.forEach((group) => {
                  const index = updatedGroups.findIndex((existingGroup) => existingGroup.id === group.id)
                  if (index !== -1) {
                    updatedGroups[index] = group
                  } else {
                    updatedGroups.push(group)
                  }
                })
                return updatedGroups
              })
            }
            setGroupsPageCountReceived((prevState) => (prevState === -1 ? 1 : prevState + 1))
          },
          (err) => {
            setGroupsPageCountExpected((prevState) => prevState - 1)
          }
        )
      }
    })
    backendGetRequest("/api/generic-tag/", { params: { page_index: 0, group_type: BA_TAG } })
      .then((res) => {
        setFlattenedTagsPageCountExpected(res?.data?.total_pages);
        for (let i = 1; i <= res?.data?.total_pages; i++) {
          backendGetRequestWithCache("api/generic-tag/", { params: { page_index: i, group_type: BA_TAG } },
            (cachedResponse) => {
              const cachedTags = cachedResponse?.data?.generic_tags || [];
              if (!cachedTags) return
              setFlattenedTags(prevState => {
                const updatedTags = prevState ? [...prevState] : [];
                cachedTags.forEach(tag => {
                  if (!updatedTags.some(existingTag => existingTag.id === tag.id)) {
                    updatedTags.push(tag);
                  }
                });
                return updatedTags;
              });
            },
            (nonCachedResponse) => {
              const nonCachedTags = nonCachedResponse?.data?.generic_tags || [];
              setFlattenedTags(prevState => {
                const updatedTags = prevState ? [...prevState] : [];
                nonCachedTags.forEach(tag => {
                  const index = updatedTags.findIndex(existingTag => existingTag.id === tag.id);
                  if (index !== -1) {
                    updatedTags[index] = tag;
                  } else {
                    updatedTags.push(tag);
                  }
                });
                return updatedTags;
              });
              setFlattenedTagsPageCountReceived(prevState => prevState === -1 ? 1 : prevState + 1);
            },
            (err) => {
              setFlattenedTagsPageCountExpected(prevState => prevState - 1);
            }
          );
        }
      });
  }, [])

  useEffect(() => {
    if (!flattenedTagsPageCountExpected) return;
    setFlattenedTagsLoading(flattenedTagsPageCountExpected > flattenedTagsPageCountReceived);
  }, [flattenedTagsPageCountExpected, flattenedTagsPageCountReceived]);

  useEffect(() => {
    if (!groupsPageCountExpected) return;
    setGroupsLoading(groupsPageCountExpected > groupsPageCountReceived);
  }, [groupsPageCountExpected, groupsPageCountReceived]);

  const columns = [
    {
      headerName: "Name",
      field: "userName",
      sortDirection: "asc",
      flex: 1,
      renderCell: (params) => {
        const { first_name, last_name } = params.row;
        let displayName = "Unknown";
        let color = "text.disabled";
        if (first_name || last_name) {
          displayName = [first_name, last_name].join(" ");
          color = "";
        }
        return (
          <Typography
            sx={{ height: "100%" }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            fontStyle={params.row.user ? "" : "italic"}
            color={params.row.user ? color : "text.disabled"}
          >
            {displayName}
          </Typography>
        );
      },
    },
    {
      headerName: "Email",
      field: "email",
      flex: 1,
      renderCell: (params) => {
        const { email } = params.row;
        return (
          <Typography
            sx={{ height: "100%" }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            fontStyle={!params.row.invited ? "" : "italic"}
            color={!params.row.invited ? "" : "text.disabled"}
          >
            {email} {params.row.invited && " (Invited)"}
          </Typography>
        );
      },
    },
    {
      headerName: "Transaction Creation Limit",
      field: "tranascation_creation_limit",
      flex: 0.5,
      renderCell: (params) => {
        const { transaction_creation_limit } = params.row;
        return <TeamPermissionField limitValue={transaction_creation_limit} />;
      },
    },
    {
      headerName: "Transaction Approval Limit",
      field: "transaction_approve_limit",
      flex: 0.5,
      renderCell: (params) => {
        const { transaction_approve_limit } = params.row;
        return <TeamPermissionField limitValue={transaction_approve_limit} />;
      },
    },
    {
      headerName: "Transaction Self-Approval Limit",
      field: "transaction_self_approve_limit",
      flex: 0.5,
      renderCell: (params) => {
        const { transaction_self_approve_limit } = params.row;
        return (
          <TeamPermissionField limitValue={transaction_self_approve_limit} />
        );
      },
    },
    {
      headerName: (
        <Stack direction="row" alignItems='center'>
          <Typography>Role</Typography>
          <Tooltip
            arrow
            title={
              <Typography>
                Click to learn more about user roles
              </Typography>
            }
          >
            <IconButton
              disableRipple
              size='small'
              onClick={(event) => {
                event.stopPropagation()
                setRoleInfoVisible(true)
              }}
            >
              <InfoOutlinedIcon
                sx={{ marginLeft: "5px" }}
                fontSize="large"
                color="disabled"
              />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
      flex: 0.5,
      field: "is_admin",
      renderCell: (params) => {
        const { id, is_admin, dashboard_editor } = params.row;
        let permission = "";
        if (is_admin) {
          permission = "Admin";
        } else if (dashboard_editor) {
          permission = "Dashboard Editor";
        } else {
          permission = "Member"
        }
        if (currentUserIsAdmin) {
          return (
            <Box
              sx={{ height: "100%" }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <TeamRoleSelect
                ucsId={id}
                currentUcsArray={userCompanyPermissions}
                setUcsArray={setUserCompanyPermissions}
              />
            </Box>
          );
        } else {
          return (
            <Typography
              sx={{ height: "100%" }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              {permission}
            </Typography>
          );
        }
      },
    },
    {
      headerName: "",
      field: "action",
      flex: 0.1,
      align: "right",
      renderCell: (params) => {
        const { id } = params.row;
        if (currentUserIsAdmin) {
          return (
            <GenericDropdown
              dropdownItems={[
                <a
                  onClick={() => {
                    setSelectedUcs(id);
                    setEditModalVisible(true);
                  }}
                >
                  Edit
                </a>,
                params?.row?.invited ? <ReinviteTeammate email={params?.row?.email} /> : undefined,
                <a
                  style={{ color: "red" }}
                  onClick={() => {
                    setSelectedUcs(id);
                    setDeleteModalVisible(true);
                  }}
                >
                  Delete
                </a>,
              ]}
            />
          );
        } else {
          return <></>;
        }
      },
    },
  ];

  if (checkFlag('limitedUserAccess')) {
    const accountAccessRow = {
      headerName: 'Account Access',
      field: 'limited_access_account_tags',
      flex: 2,
      renderCell: (params) => {
        const { limited_access_account_tags } = params.row
        return limited_access_account_tags ? (
          <GenericTagChips genericTags={limited_access_account_tags} />
        ) : (
          <Typography variant='primary'>All</Typography>
        )
      },
    }
    columns.splice(2, 0, accountAccessRow)
  }


  useEffect(() => {
    if (!ucsLoaded) {
      return
    }
    let toolTipText = 'Users without saved numbers: '
    const withoutPhones = userCompanyPermissions.filter((ucsObject) => {
      if (!ucsObject.phone_number) {
        toolTipText = `${toolTipText} ${ucsObject.user_display_name.trim()}, `
        return true
      }
      return false
    })
    toolTipText = toolTipText.replace(/,\s*$/, '')
    setPhoneNumberTooltip(toolTipText)
    setUsersWithoutPhoneNumber(withoutPhones)
  }, [userCompanyPermissions])

  return (
    <OuterBox>
      <HeaderBox
        title="Team"
        actions={
          currentUserIsAdmin && (
            <Button
              variant="contained"
              color="primary"
              sx={{ fontSize: 14, textTransform: 'none' }}
              onClick={() => {
                setInviteModalVisible(true);
              }}
            >+ Invite Teammates</Button>
          )
        }
      />
      <>
        {(isSoftwareCustomer && usersWithoutPhoneNumber.length > 0) && (
          <Tooltip title={<Typography>{phoneNumberToolTip}</Typography>} arrow >
            <span>
              <StyledAlert message={isBankingCustomer ? 'In addition to normal permissions, users must have a phone number in order to send/approve payments from non-Arpari accounts. Users may add their phone number on the profile page.' : 'In addition to normal permissions, users must have a phone number in order to send/approve payments. Users may add their phone number on the profile page.'} />
            </span>
          </Tooltip>
        )}
        {ucsLoaded ? (
          <TableWithLoadingWrapper
            pagination={false}
            columns={columns}
            dataSource={userCompanyPermissions}
            tableLayout={"fixed"}
            style={{ width: "100%" }}
            sortModel={[
              {
                field: "isAdmin",
                sort: "desc",
              },
            ]}
            loading={!ucsLoaded}
            getRowId={(row) => row.id || row.email}
          />
        ) : (
          <Stack
            sx={{
              width: "100%",
              margin: 0,
              alignItems: "flex-start"
            }}
          >
            <Skeleton variant="text" width="100%" height="300px" />
          </Stack>
        )}
      </>

      <TeamDeleteModal
        modalVisible={deleteModalVisible}
        setModalVisible={() => setDeleteModalVisible(false)}
        ucsId={selectedUcs}
        currentUserCompanyPermissions={userCompanyPermissions}
        setUserCompanyPermissions={setUserCompanyPermissions}
      />
      <TeamInviteModal
        modalVisible={inviteModalVisible}
        setModalVisible={() => setInviteModalVisible(false)}
        currentUserCompanyPermissions={userCompanyPermissions}
        setUserCompanyPermissions={setUserCompanyPermissions}
      />
      <TeamPermissionModal
        groups={groups}
        customTags={flattenedTags}
        loading={flattenedTagsLoading || groupsLoading}
        modalVisible={editModalVisible}
        setModalVisible={() => setEditModalVisible(false)}
        currentUserCompanyPermissions={userCompanyPermissions}
        setUserCompanyPermissions={setUserCompanyPermissions}
        ucsId={selectedUcs}
      />
      <TeamRolesInfoModal
        visible={roleInfoVisible}
        handleClose={() => setRoleInfoVisible(false)}
      />
    </OuterBox>
  );
}

export default TeamPermissions;
